<template>
  <v-dialog
    :value="dialog"
    :max-width="350"
    content-class="d-dialog"
    @keydown.enter="submit"
    @keydown.esc="closeDialog"
    @click:outside="closeDialog"
  >
    <v-card outlined class="d-dialog-card">
      <v-card-title>
        {{ $t('vehicle.licenseNumberDialog.title') }}
        <d-btn-icon
          type="close"
          btn-class="d-dialog-btn-close"
          tabindex="4"
          @click="closeDialog"
        ></d-btn-icon>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form ref="form" @submit.stop.prevent>
<!--          <v-text-field-->
<!--            ref="licenseNumber"-->
<!--            v-model.trim="licenseNumber"-->
<!--            :rules="rules.licenseNumber"-->
<!--            :placeholder="$t('vehicle.edit.licenseNumber')"-->
<!--            :hint="$t('vehicle.edit.licenseNumber_hint')"-->
<!--            tabindex="1"-->
<!--            autofocus-->
<!--            @keydown="preventWhitespaceInput"-->
<!--            @input="onLicenseNumberInput"-->
<!--          ></v-text-field>-->
<!--          <v-text-field-->
<!--            ref="vinNumber"-->
<!--            v-model.trim="vinNumber"-->
<!--            :rules="rules.vinNumber"-->
<!--            :placeholder="$t('vehicle.edit.vinNumber')"-->
<!--            :hint="$t('vehicle.edit.vinNumber_hint')"-->
<!--            tabindex="1"-->
<!--            @keydown="preventWhitespaceInput"-->
<!--            @input="onVinNumberInput"-->
<!--          ></v-text-field>-->
              <v-text-field
                ref="keyword"
                v-model.trim="keyword"
                :rules="rules.keyword"
                :placeholder="$t('vehicle.edit.keyword')"
                :hint="$t('vehicle.edit.keyword_hint')"
                tabindex="1"
                @keydown="preventWhitespaceInput"
                @input="onKeywordInput"
              ></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn
          v-text="$t('cancel')"
          color="secondary"
          text
          tabindex="3"
          @click="closeDialog"
        ></v-btn>
        <v-btn
          v-text="$t('next')"
          :disabled="!keyword"
          color="primary"
          text
          tabindex="2"
          @click="submit"
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'
import { vehicleSchema } from '@/constants'

import dialogMixin from '@/mixins/dialog.mixin'
import snackbarMixin from '@/mixins/snackbar.mixin'
import validationMixin from '@/mixins/validation.mixin'
import errorMixin from '@/mixins/error.mixin'
// import licenseNumberMixin from '@/mixins/licenseNumber.mixin'
// import vinNumberMixin from '@/mixins/vinNumber.mixin'
import keywordMixin from '@/mixins/keyword.mixin'

import DBtnIcon from '@/components/DBtnIcon'


export default {
  components: {
    DBtnIcon
  },


  mixins: [
    dialogMixin,
    snackbarMixin,
    validationMixin,
    errorMixin,
    // licenseNumberMixin,
    // vinNumberMixin,
    keywordMixin
  ],


  data () {
    return {
      // licenseNumber: '',
      // vinNumber: '',
      keyword: ''
    }
  },


  computed: {
    ...mapGetters('dealer', ['currentDealerId', 'shortDealerById']),
    ...mapGetters('user', ['currentUser', 'currentUserIsChainAdmin']),
    ...mapGetters('chain', ['currentChainId']),

    rulesToApply () {
      const rule = this.rule

      if (this.keyword.length <= vehicleSchema.licenseNumberMaxLength) {
        return {
          keyword: [rule.required(), rule.maxLength(vehicleSchema.licenseNumberMaxLength)]
        }
      } else {
        return {
          keyword: [rule.vinNumber()]
        }
      }
      // return {
      //   licenseNumber: [rule.maxLength(vehicleSchema.licenseNumberMaxLength)],
      //   vinNumber: [rule.vinNumber()],
      // }
    }
  },


  methods: {
    ...mapActions('vehicle', ['getVehicleByKeyword', 'moveVehicle']),

    onDialogOpen () {
      // this.licenseNumber = ''
      // this.vinNumber = ''
      this.keyword = ''
      this.resetValidation()
    },

    // onLicenseNumberInput () {
    //   this.licenseNumber = this.fixLicenseNumber(this.licenseNumber)
    // },
    //
    // onVinNumberInput () {
    //   this.vinNumber = this.fixVinNumber(this.vinNumber)
    // },

    onKeywordInput () {
      this.keyword = this.fixKeyword(this.keyword)
    },

    async getVehicleByKeyword_ (keyword, chainId) {
      let vehicle = null

      try {
        this.showSnackbarProcessing()
        vehicle = await this.getVehicleByKeyword({ keyword, chainId })
      } catch (error) {
        if (!this.is404NotFoundError(error)) {
          this.hideSnackbar()
          throw error
        }
      }

      this.hideSnackbar()

      return vehicle
    },

    async submit () {
      const valid = await this.validate(this.rulesToApply)
      // if (!valid || (!this.licenseNumber && !this.vinNumber)) return
      if (!valid || !this.keyword) return

      // const keyword = this.licenseNumber || this.vinNumber

      try {
        let vehicle = await this.getVehicleByKeyword_(this.keyword, this.currentUser.chainId)
        if (!vehicle) {
          if (this.keyword.length <= vehicleSchema.licenseNumberMaxLength) {
            this.$emit('create', { licenseNumber: this.keyword, vinNumber: '' })
          } else {
            this.$emit('create', { licenseNumber: '', vinNumber: this.keyword })
          }
          this.closeDialog()
        } else if (vehicle.dealerId === this.currentDealerId) {
          this.$emit('edit', vehicle)
          this.closeDialog()
        } else {
          const dealerName = this.shortDealerById(vehicle.dealerId)?.name

          const confirmMoving = await this.$confirm(this.$t('vehicle.moveVehicleConfirm',
            { licenseNumber: vehicle.licenseNumber, vinNumber: vehicle.vinNumber, dealer: dealerName }), { trueText: this.$t('vehicle.moveVehicle') })

          if (confirmMoving) {
            this.showSnackbarProcessing()
            const chainId = this.currentUserIsChainAdmin ? this.currentChainId : this.currentUser.chainId
            vehicle = await this.moveVehicle({ dealerId: this.currentDealerId, vehicle, chainId })
            this.showSnackbarSuccess(this.$t('vehicle.vehicleMoved'))
            this.$emit('moved', vehicle)
            this.$emit('edit', vehicle)
            this.closeDialog()
          } else {
            this.$refs.licenseNumber.focus()
          }
        }
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    }
  }
}
</script>
